import { ISample } from "./models/ISample";
import { IQuestion } from "./models/IQuestion";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import { NgbTime } from "@ng-bootstrap/ng-bootstrap/timepicker/ngb-time";
import { IQuota } from "./models/IQuota";
import { IQuotaTable } from "./models/IQuotaTable";

export class Utils {

  public static generateUUID(): string {
    let seed = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
      seed += performance.now(); // use high-precision timer if available
    }
    let uuid: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (char: string): string {
        /*jshint bitwise: false*/
        let r = (seed + Math.random() * 16) % 16 | 0;
        seed = Math.floor(seed / 16);
        return (char === "x" ? r : (r & 0x3 | 0x8)).toString(16);
        /*jshint bitwise: true*/
      }
    );
    return uuid.toLocaleUpperCase();//to match sql server newid() ;-)
  }

  public static getCostDurations(sample: ISample): string[] {
    let lst = [];
    for (let key in sample.costs)
      lst.push(key);
    return lst.sort(Utils.sortCompleteLabels);
  }

  public static sortCompleteLabels(a: string, b: string) {
    if (a.toLowerCase().indexOf('h') > 0 && b.toLowerCase().indexOf('h') == -1)//put [H]ours before [D]ays
      return -1;
    if (a.toLowerCase().indexOf('d') > 0 && b.toLowerCase().indexOf('d') == -1)
      return 1;
    return parseInt(a) - parseInt(b); //then in numeric order
  }

  public static AllDurations(): string[] {
    return "4h,12h,16h,1d,2d,3d,4d,5d,6d,7d".split(",");
  }

  public static HoursToFieldDurLables(hours: number, flexOn: boolean): string[] {
    if (flexOn)
      return Utils.AllDurations();
    else {
      if (hours >= 0 && hours <= 11)
        return ["4h"];

      if (hours >= 12 && hours <= 15)
        return ["12h"];

      if (hours >= 16 && hours <= 23)
        return ["16h"];

      if (hours >= 24 && hours <= 47)
        return ["1d"];

      if (hours >= 48 && hours <= 71)
        return ["2d"];

      if (hours >= 72 && hours <= 95)
        return ["3d"];

      if (hours >= 96 && hours <= 119)
        return ["4d"];

      if (hours >= 120 && hours <= 143)
        return ["5d"];

      if (hours >= 144 && hours <= 167)
        return ["6d"];

      if (hours >= 168)
        return ["7d"];

      return ["4h"];
    }
  }

  public static getErrorDetailsString(err): string {
    if (err.error && err.error.errors) {
      let details = "";
      for (let e in err.error.errors) {
        details += `${e}:${err.error.errors[e]} `;
      }
      return details;
    }
    return "";
  }


  public static visitQuestionInSample(sample: ISample, visit: (question: IQuestion) => void) {
    for (let t of (sample.target || [])) {
      for (let q of (t.questions || [])) {
        visit(q);
      }
    }
    for (let qt of (sample.quotaTables || [])) {
      for (let quota of (qt.quotas || [])) {
        for (let q of (quota.questions || [])) {
          visit(q);
        }
      }
    }
  }

  public static formatNgbDateAsUTC(dateToConvert: NgbDate) {
    if (dateToConvert != null)
      return '' + dateToConvert.year + '-' + dateToConvert.month + '-' + dateToConvert.day + 'T00:00:00.000Z';
    else return '';
    //if needed pad(n) { return n < 10 ? '0' + n : n }
  }

  public static formatNgbDateTimeAsUTC(dateToConvert: NgbDate, time: NgbTime) {
    if (dateToConvert != null)
      return '' + dateToConvert.year + '-' + dateToConvert.month + '-' + dateToConvert.day + `T${time.hour < 10 ? "0" : ""}${time.hour}:${time.minute < 10 ? "0" : ""}${time.minute}:00.000Z`;
    else return '';
    //if needed pad(n) { return n < 10 ? '0' + n : n }
  }



  public static toTwo(num: number): number {
    return Math.round(num * Math.pow(10, 2)) / Math.pow(10, 2);
  }

}



// WEBPACK FOOTER //
// ./src/app/Utils.ts